export default "__VITE_ASSET__BDXcxIpA__"